import { DialogBaseComponent, DialogParams } from "@/shared/dialog-base.component";
import { DomainService } from "@/shared/domain.service";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ItemDetail } from "app/model/entities/entity-model";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

export interface ItemDetailLogDialogParams extends DialogParams {
  itemDetail: ItemDetail;
}

@Component({
  templateUrl: "./item-detail-log-dialog.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ItemDetailLogDialogComponent
  extends DialogBaseComponent<ItemDetailLogDialogParams>
  implements OnInit
{
  itemDetail: ItemDetail;
  isPageReady = false;

  constructor(
    public config: DynamicDialogConfig<ItemDetailLogDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    this.itemDetail = this.params.itemDetail;
    this.config.header = "Item Detail Chronology";
    this.config.width = "63vw";
    this.config.height = "80vh";
  }

  async ngOnInit() {
    // Ensure the ItemDetail is fully expanded (manufacturer + productType)
    // regardless of what the caller passed in.
    if (this.itemDetail?.id) {
      const fresh = await this.dbQueryService.getItemDetailById(this.itemDetail.id);
      if (fresh) this.itemDetail = fresh;
    }
    this.isPageReady = true;
  }

  get manufacturerName(): string {
    return this.itemDetail?.product?.productType?.manufacturer?.name ?? "";
  }

  get style(): string {
    return this.itemDetail?.product?.productType?.style ?? "";
  }

  get description(): string {
    return this.itemDetail?.product?.productType?.description ?? "";
  }

  get ownership(): string {
    const accountName = this.itemDetail?.account?.accountName;
    return accountName ? `${accountName}-owned` : "Supplier-owned";
  }

  close() {
    this.dialogRef.close();
  }
}
